module.exports = __webpack_public_path__ + "img/cb-lr-n1.a2c6c27e.gif";